<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>营地订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="conentBox">
      <div class="conentTitle">
        <el-input placeholder="订单号" v-model="query.order_no" clearable />
        <el-input placeholder="产品名称" v-model="query.product_name" clearable />
        <el-input placeholder="手机号" v-model="query.contact_phone" clearable />
        <el-select v-model="query.order_status" placeholder="订单状态" clearable>
          <el-option label="待支付" value="0"></el-option>
          <el-option label="已支付" value="1"></el-option>
          <el-option label="已取消" value="2"></el-option>
          <el-option label="已退款" value="3"></el-option>
          <el-option label="已使用" value="4"></el-option>
          <el-option label="失效" value="5"></el-option>
        </el-select>
        <el-select v-model="query.pay_type" placeholder="支付方式" clearable>
          <el-option label="微信" value="1"></el-option>
        </el-select>
        <el-date-picker
          v-model="dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-button type="primary" @click="search">查询</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="loading"
        :header-cell-style="tableHeaderColor"
        :cell-style="cellStyle"
        style="width:100%"
      >
        <el-table-column prop="created_at" label="下单时间" min-width="160"></el-table-column>
        <el-table-column prop="order_no" label="订单号" min-width="190"></el-table-column>
        <el-table-column prop="product_name" label="产品名称" min-width="160"></el-table-column>
        <el-table-column prop="spec_name" label="规格" min-width="140" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contact_name" label="联系人" width="100"></el-table-column>
        <el-table-column prop="contact_phone" label="手机号" width="120"></el-table-column>
        <el-table-column prop="sale_price" label="营期售价" width="100"></el-table-column>
        <el-table-column prop="single_price" label="单价" width="100"></el-table-column>
        <el-table-column prop="total_amount" label="总金额" width="100"></el-table-column>
        <el-table-column label="支付方式" width="90">
          <template slot-scope="scope">
            {{ payTypeText(scope.row.pay_type) }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <span>{{ statusText(scope.row.order_status) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="openDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="demonstration">共{{ total }}条记录，</span>
        <span class="demonstration">当前显示第{{ query.page }}页</span>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="query.page_size"
          :current-page="query.page"
          @current-change="onPageChange"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog
      :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="detailVisible"
      width="860px"
      center
    >
      <el-divider></el-divider>
      <div v-loading="detailLoading" class="detail-wrap" v-if="detail">
        <div class="section-title">订单信息</div>
        <div class="detail-grid">
          <div><span>订单号：</span>{{ detail.order_no }}</div>
          <div><span>状态：</span>{{ statusText(detail.order_status) }}</div>
          <div><span>产品：</span>{{ detail.product_name }}</div>
          <div><span>营期：</span>{{ detail.date_title || '-' }}</div>
          <div><span>营期售价：</span>{{ detail.sale_price }}</div>
          <div><span>单价：</span>{{ detail.single_price }}</div>
          <div><span>总金额：</span>{{ detail.total_amount }}</div>
          <div><span>联系人：</span>{{ detail.contact_name }}</div>
          <div><span>手机号：</span>{{ detail.contact_phone }}</div>
          <div><span>支付方式：</span>{{ payTypeText(detail.pay_type) }}</div>
          <div><span>支付流水：</span>{{ detail.pay_no || '-' }}</div>
          <div><span>下单时间：</span>{{ detail.created_at }}</div>
          <div><span>支付时间：</span>{{ detail.pay_time || '-' }}</div>
          <div><span>规格：</span>{{ detail.spec_name || '-' }}</div>
          <div><span>退款流水：</span>{{ detail.refund_no || '-' }}</div>
          <div><span>退款时间：</span>{{ detail.refund_time || '-' }}</div>
          <div><span>退款金额：</span>{{ detail.refund_amount || '-' }}</div>
        </div>
        <div class="detail-desc" v-if="detail.product_desc">
          <div class="desc-label">产品简介：</div>
          <div class="desc-html" v-html="detail.product_desc"></div>
        </div>

        <div class="section-title">报名学员</div>
        <el-table :data="detail.visitor_list || []" size="small" border>
          <el-table-column prop="name" label="学员姓名" min-width="100"></el-table-column>
          <el-table-column prop="gender" label="性别" width="70"></el-table-column>
          <el-table-column prop="age" label="年龄" width="70"></el-table-column>
          <el-table-column prop="id_card" label="身份证号" min-width="170" show-overflow-tooltip></el-table-column>
          <el-table-column prop="phone" label="家长联系电话" min-width="130"></el-table-column>
          <el-table-column prop="address" label="家庭住址" min-width="140" show-overflow-tooltip></el-table-column>
          <el-table-column prop="school" label="就读学校" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="height" label="身高" width="80"></el-table-column>
          <el-table-column prop="weight" label="体重" width="80"></el-table-column>
          <el-table-column prop="shoe_size" label="鞋码" width="80"></el-table-column>
          <el-table-column prop="cert_level" label="已取得的证书板别及级别" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip></el-table-column>
        </el-table>

        <div class="section-title" v-if="(detail.spec_list || []).length">选中规格</div>
        <div v-if="(detail.spec_list || []).length" class="spec-list">
          <span v-for="(s, i) in detail.spec_list" :key="i" class="spec-tag">
            {{ s.group_name }}：{{ s.item_name }}
          </span>
        </div>

        <div class="section-title" v-if="(detail.itinerary_list || []).length">行程安排</div>
        <el-table v-if="(detail.itinerary_list || []).length" :data="detail.itinerary_list" size="small" border>
          <el-table-column prop="day" label="天数" width="70"></el-table-column>
          <el-table-column prop="time_point" label="时间" width="90"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="content" label="内容" show-overflow-tooltip></el-table-column>
          <el-table-column prop="duration" label="时长(时)" width="90"></el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { campGetOrderList, campOrderDetail } from '@/request/scenic.js'

export default {
  data() {
    return {
      loading: false,
      detailLoading: false,
      detailVisible: false,
      detail: null,
      tableData: [],
      total: 0,
      dateRange: [],
      query: {
        token: window.sessionStorage.getItem('Token'),
        order_no: '',
        product_name: '',
        contact_phone: '',
        order_status: '',
        pay_type: '',
        start_time: '',
        end_time: '',
        page: 1,
        page_size: 8
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    statusText(v) {
      // 0待支付 1已支付 2已取消 3已退款 4已使用 5失效
      const map = {
        0: '待支付',
        1: '已支付',
        2: '已取消',
        3: '已退款',
        4: '已使用',
        5: '失效'
      }
      return map[v] != null ? map[v] : map[String(v)] || '-'
    },
    payTypeText(v) {
      const map = { 1: '微信', 2: '支付宝' }
      return map[v] != null ? map[v] : map[String(v)] || '-'
    },
    search() {
      this.query.page = 1
      this.getList()
    },
    onPageChange(p) {
      this.query.page = p
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
        token: window.sessionStorage.getItem('Token'),
        page: this.query.page,
        page_size: this.query.page_size
      }
      ;['order_no', 'product_name', 'contact_phone', 'order_status', 'pay_type'].forEach(k => {
        if (this.query[k] !== '' && this.query[k] != null) params[k] = this.query[k]
      })
      if (this.dateRange && this.dateRange.length === 2) {
        params.start_time = this.dateRange[0]
        params.end_time = this.dateRange[1]
      }
      campGetOrderList(params).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          const result = res.data.result || {}
          this.tableData = result.list || []
          this.total = result.total || 0
        } else {
          this.tableData = []
          this.total = 0
          if (res.data && res.data.msg) Message.error(res.data.msg)
        }
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    openDetail(row) {
      this.detailVisible = true
      this.detail = null
      this.detailLoading = true
      campOrderDetail({
        token: window.sessionStorage.getItem('Token'),
        order_no: row.order_no
      }).then(res => {
        if (res.data && (res.data.status === 'ok' || res.data.rcode == 200)) {
          this.detail = res.data.result || null
        } else {
          Message.error((res.data && res.data.msg) || '获取详情失败')
        }
      }).catch(() => {
        Message.error('获取详情失败')
      }).finally(() => {
        this.detailLoading = false
      })
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({ row, column, rowIndex, columnIndex })
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({ row, rowIndex })
    }
  }
}
</script>

<style lang="less" scoped>
.conentBox {
  margin-top: 17px;
}
.conentTitle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  .el-input, .el-select {
    width: 160px;
  }
  .el-button {
    background: #246DEB;
    border-color: #246DEB;
  }
}
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 42px auto;
  span {
    font-size: 14px;
    color: #000;
  }
}
.section-title {
  font-size: 15px;
  font-weight: 600;
  margin: 18px 0 10px;
  color: #333;
}
.detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 16px;
  font-size: 14px;
  color: #666;
  span {
    color: #999;
  }
}
.detail-desc {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  .desc-label {
    color: #999;
    margin-bottom: 6px;
  }
  .desc-html {
    /deep/ p {
      margin: 0 0 6px;
    }
    /deep/ img {
      max-width: 100%;
    }
  }
}
.spec-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  .spec-tag {
    background: #f0f6ff;
    color: #246DEB;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 13px;
  }
}
/deep/ .el-dialog__body {
  padding: 0 20px 20px;
}
/deep/ .el-divider--horizontal {
  margin: 0 0 16px;
}
</style>
